import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'tf2006',
    ecrans: [
        '00-2'
    ]
});
